import React from "react";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Title } from "./components/Title";
import { Cta } from "./components/Cta";

export const ServicesPage = () => {
    return (
        <>
        <Header />
        <Title title="Servisi" />
        <main>
            
            {/* <!-- Latest Service Area Start --> */}
            <section className="latest-service-area tmp-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-sm-6">
                            <div className="service-card-v2 tmponhover tmp-scroll-trigger tmp-fade-in animation-order-1">
                                <h2 className="service-card-num"><span>01.</span>Custom izrada web sajta</h2>
                                <p className="service-para">Potpuno prilagođeni dizajn i funkcionalnosti koje odgovaraju vašem brendu i poslovnim ciljevima.</p>
                            </div>
                            <div className="service-card-v2 tmponhover tmp-scroll-trigger tmp-fade-in animation-order-2">
                                <h2 className="service-card-num"><span>02.</span>E-commerce rešenja</h2>
                                <p className="service-para">Postavljanje online prodavnice sa sigurnim plaćanjem, integracijama i automatskim procesima.</p>
                            </div>
                            <div className="service-card-v2 tmponhover tmp-scroll-trigger tmp-fade-in animation-order-3">
                                <h2 className="service-card-num"><span>03.</span>Responsive razvoj</h2>
                                <p className="service-para">Vaš sajt izgleda savršeno na svim uređajima zahvaljujući responsive dizajnu i brzim performansama.</p>
                            </div>
                            <div className="service-card-v2 tmponhover tmp-scroll-trigger tmp-fade-in animation-order-4">
                                <h2 className="service-card-num"><span>04.</span>UX/UI dizajn</h2>
                                <p className="service-para">Kreiramo wireframe, prototipe i finalni dizajn koji komunicira vrednost i vodi korisnike kroz sadržaj.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                            <div className="service-card-v2 tmponhover tmp-scroll-trigger tmp-fade-in animation-order-5">
                                <h2 className="service-card-num"><span>05.</span>SEO optimizacija</h2>
                                <p className="service-para">Strategijski pristup optimizaciji da ključna fraza "izrada web sajta cena" donese organski saobraćaj i konverzije.</p>
                            </div>
                            <div className="service-card-v2 tmponhover tmp-scroll-trigger tmp-fade-in animation-order-6">
                                <h2 className="service-card-num"><span>06.</span>Tehnička optimizacija</h2>
                                <p className="service-para">Implementiramo performantne tehnologije, optimizujemo brzinu, Core Web Vitals i sigurnosne prakse.</p>
                            </div>
                            <div className="service-card-v2 tmponhover tmp-scroll-trigger tmp-fade-in animation-order-6">
                                <h2 className="service-card-num"><span>07.</span>Google oglašavanje</h2>
                                <p className="service-para">Implementiramo Google oglašavanje kako biste odmah dobili potencijalne klijente.</p>
                            </div>
                            <div className="service-card-v2 tmponhover tmp-scroll-trigger tmp-fade-in animation-order-6">
                                <h2 className="service-card-num"><span>08.</span>Održavanje i podrška</h2>
                                <p className="service-para">Kontinuirano unapređenje, sigurnosne provere i podrška kako bi vaš sajt uvek bio online.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Latest Service Area End --> */}
           
            <Cta klasa="itu-padding-top-none" />
        </main>
        <Footer />
        </>
    );
}